export enum AvailableFeatures {
    AsAppliedMaps = 'asAppliedMaps',
    AsCoveredMaps = 'asCoveredMaps',
    Ddm = 'ddm',
    EaVision = 'eaVision',
    FieldView = 'fieldview',
    FaaReports = 'faaReports',
    FlightLogs = 'flightLogs',
    InvoiceAssistant = 'invoiceAssistant',
    JohnDeere = 'johnDeere',
    OrgizationActivityReports = 'orgizationActivityReports',
    ProductUsageReports = 'productUsageReports',
    ProductUsageReportActivityReports = 'productUsageReportActivityReports',
    Quickbooks = 'quickbooks',
    ServiceProviders = 'serviceProviders',
    WorkOrderActivityReports = 'workOrderActivityReports',
    WorkOrders = 'workOrders'
}

export enum FeatureFlag {
    AsAppliedMaps = 'feature:as-applied-maps',
    AsCoveredMaps = 'feature:as-covered-maps',
    Ddm = 'feature:ddm',
    EaVision = 'feature:eavision',
    FaaReports = 'feature:faa-reports',
    Fieldview = 'feature:fieldview',
    FlightLogs = 'feature:flight-logs',
    InvoiceAssistant = 'feature:invoice-assistant',
    JohnDeere = 'feature:john-deere',
    OrgActivityReports = 'feature:org-activity-reports',
    ProductUsageReports = 'feature:product-usage-reports',
    ProductUsageReportActivityReports = 'feature:pur-activity-reports',
    Quickbooks = 'feature:quickbooks',
    ServiceProviders = 'feature:service-providers',
    WorkOrderActivityReports = 'feature:wo-activity-reports',
    WorkOrders = 'feature:work-orders'
}

export const FEATURE_MAP: Record<FeatureFlag, AvailableFeatures> = {
    [FeatureFlag.AsAppliedMaps]: AvailableFeatures.AsAppliedMaps,
    [FeatureFlag.AsCoveredMaps]: AvailableFeatures.AsCoveredMaps,
    [FeatureFlag.Ddm]: AvailableFeatures.Ddm,
    [FeatureFlag.EaVision]: AvailableFeatures.EaVision,
    [FeatureFlag.FaaReports]: AvailableFeatures.FaaReports,
    [FeatureFlag.Fieldview]: AvailableFeatures.FieldView,
    [FeatureFlag.FlightLogs]: AvailableFeatures.FlightLogs,
    [FeatureFlag.InvoiceAssistant]: AvailableFeatures.InvoiceAssistant,
    [FeatureFlag.JohnDeere]: AvailableFeatures.JohnDeere,
    [FeatureFlag.OrgActivityReports]: AvailableFeatures.OrgizationActivityReports,
    [FeatureFlag.ProductUsageReports]: AvailableFeatures.ProductUsageReports,
    [FeatureFlag.ProductUsageReportActivityReports]:
        AvailableFeatures.ProductUsageReportActivityReports,
    [FeatureFlag.Quickbooks]: AvailableFeatures.Quickbooks,
    [FeatureFlag.ServiceProviders]: AvailableFeatures.ServiceProviders,
    [FeatureFlag.WorkOrderActivityReports]: AvailableFeatures.WorkOrderActivityReports,
    [FeatureFlag.WorkOrders]: AvailableFeatures.WorkOrders
};
